export default "__VITE_ASSET__bb08f04d__"